import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

if (document.querySelector('.a-classic-win-win')) {
	var wrapper = document.querySelector('.section--magazine')
  var personSledge = document.querySelector('.win-win__animation')
	var triggerOne = document.querySelector('.winwin__trigger--1')
	var triggerTwo = document.querySelector('.winwin__trigger--2')
	var triggerThree = document.querySelector('.winwin__trigger--3')
	var triggerFour = document.querySelector('.winwin__trigger--4')
  var indicator = document.querySelector('.win-win__scroll')


	ScrollTrigger.create({
	  trigger: triggerOne,
	  start: "top 50%",
	  end: "bottom 0%",
	  scrub: true,
      onEnter: () => personSledge.classList.add('winwin--stateOne-active'),
      onLeave: () => personSledge.classList.remove('winwin--stateOne-active'),
      onEnterBack: () => personSledge.classList.add('winwin--stateOne-active'),
      onLeaveBack: () => personSledge.classList.remove('winwin--stateOne-active'),
	});

	ScrollTrigger.create({
	  trigger: triggerTwo,
	  start: "top 50%",
	  end: "bottom 0%",
	  scrub: true,
      onEnter: () => personSledge.classList.add('winwin--stateTwo-active'),
      onLeave: () => personSledge.classList.remove('winwin--stateTwo-active'),
      onEnterBack: () => personSledge.classList.add('winwin--stateTwo-active'),
      onLeaveBack: () => personSledge.classList.remove('winwin--stateTwo-active'),
	});

	ScrollTrigger.create({
	  trigger: triggerThree,
	  start: "top 50%",
	  // end: "bottom -110%",
    // markers: true,
	  scrub: true,
      onEnter: () => personSledge.classList.add('winwin--stateThree-active'),
      onLeave: () => personSledge.classList.remove('winwin--stateThree-active'),
      onEnterBack: () => personSledge.classList.add('winwin--stateThree-active'),
      onLeaveBack: () => personSledge.classList.remove('winwin--stateThree-active'),
	});


	// ScrollTrigger.create({
	//   trigger: triggerFour,
	//   start: "top 50%",
	//   end: "bottom 0%",
	//   scrub: true,
  //     onEnter: () => personSledge.classList.add('winwin--stateFour-active'),
  //     onEnterBack: () => personSledge.classList.remove('winwin--stateFour-active'),
	// });





	// BLUT NET
	var blueNet = document.querySelector('.win-win__animation-right .win-win__animation-svg')
	var tl = gsap.timeline({
		scrollTrigger:{
		  trigger: triggerOne,
		  scrub: 1,
		  start: 'top center',
		  end:'bottom center',
		}
	})
	tl.to(blueNet, {scale: 0.5, rotate: '50deg'})
	tl.to(blueNet, {scale: 1, rotate: '-50deg'})
	tl.to(blueNet, {opacity: 0})

	// RED NET
	var redNet = document.querySelector('.win-win__animation-left .win-win__animation-svg')
	var tl2 = gsap.timeline({
		scrollTrigger:{
		  trigger: triggerOne,
		  scrub: 1,
		  start: 'top center',
		  end:'bottom center',
		}
	})
	tl2.to(redNet, {scale: 0.5, rotate: '-50deg'})
	tl2.to(redNet, {scale: 1, rotate: '+50deg'})
	tl2.to(redNet, {opacity: 0})


}
